<template>
  <transition name="fade">
    <div class="overlay">
      <div class="overlay__mask" @click="emitClose()"></div>

      <div class="overlay__wrapper">
        <div class="overlay__content">
          <slot />
        </div>

        <div v-if="hasButtons" class="overlay__buttons">
          <slot name="buttons"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * 共通 オーバーレイテンプレート
 */
export default defineComponent({
  name: 'CommonOverlaySection',
  props: {
    /**
     * 下部ボタンエリアの有無
     */
    hasButtons: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    emitClose(): void {
      /**
       * closeModal
       * 親コンポーネントへ閉じる処理を通知
       */
      this.$emit('close')
    },
  },
})
</script>

<style lang="scss">
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px;
  transition: all ease 0.3s;
  z-index: 50;

  &.fade-enter-active,
  &.fade-leave-active {
    opacity: 1;
    pointer-events: auto;
  }

  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
    pointer-events: none;
  }

  &__mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 70%);
  }

  &__wrapper {
    position: relative;
    width: min(100%, 470px);
    max-height: calc(100vh - 116px);
    padding: 0;
    overflow-y: auto;
    background: $gray1;
    border-radius: 8px;
  }

  &__content {
    width: 100%;
    padding: 0 16px;
  }

  &__buttons {
    display: flex;
    flex-flow: row wrap;
    gap: 8px;
    margin-top: 20px;
    padding: 16px;
  }
}
</style>
